module.exports = __webpack_public_path__ + "static/img/bg.a77d27b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/bg.png
// module id = bV6S
// module chunks = 1